// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__c8Cj6","alertIcon":"ConfirmModal_alertIcon__29fox"};